(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // scripts/tools/section.ts
  var ATTR_SECTION_INITIALIZED = "data-section-initialized";
  var _Section = class _Section {
    constructor(element, selector) {
      // Class itself.
      __publicField(this, "selector");
      __publicField(this, "container");
      __publicField(this, "shopifyContainer");
      __publicField(this, "id");
      __publicField(this, "innerHtmlObserver");
      __publicField(this, "onInnerHtmlMutationObserved", (mutations, observer) => {
        if (!mutations.length) return;
        if (!this.shopifyContainer) return;
        const [mutation] = mutations;
        const removedNodes = [];
        mutation.removedNodes.forEach((n) => removedNodes.push(n));
        const index = removedNodes.findIndex((rn) => rn === this.shopifyContainer);
        if (index === -1) return;
        console.log("Section", this.id, "reloaded.");
        this.dispose();
        _Section.recheck(this.selector);
      });
      this.container = element;
      this.selector = selector;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.shopifyContainer = this.container.parentElement;
      if (this.shopifyContainer && this.shopifyContainer.id) {
        try {
          this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
        } catch (e) {
          console.warn(e);
        }
      }
    }
    /**
     * Register a given section handler for a section selector.
     * 
     * @param selector Selector used to query on the section(s).
     * @param t The handling class for that section.
     * @returns The list of currently registered sections.
     */
    static register(selector, t) {
      const sections = [];
      document.querySelectorAll(selector).forEach((element) => {
        if (_Section.isRegistered(element)) return;
        const sect = new t(element, selector);
        sections.push(sect);
        sect.queryChildren(element);
        sect.init();
        sect.attachEvents(element);
      });
      this.registrations[selector] = t;
      return sections;
    }
    static recheck(selector) {
      const t = this.registrations[selector];
      if (!t) return [];
      return _Section.register(selector, t);
    }
    /**
     * Checks if the given section has been registered or not.
     * 
     * @param element Element to check if has been registered.
     * @returns True if registered, otherwise false.
     */
    static isRegistered(element) {
      return element.hasAttribute(ATTR_SECTION_INITIALIZED);
    }
    replaceContainer(newContainer) {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      this.container.innerHTML = newContainer.innerHTML;
      this.container.setAttribute(ATTR_SECTION_INITIALIZED, "true");
      this.queryChildren(this.container);
      this.init();
      this.attachEvents(this.container);
    }
    init() {
    }
    dispose() {
      this.container.removeAttribute(ATTR_SECTION_INITIALIZED);
      this.detatchEvents(this.container);
      if (this.innerHtmlObserver) this.innerHtmlObserver.disconnect();
    }
  };
  __publicField(_Section, "registrations", {});
  var Section = _Section;

  // scripts/sections/flip-page-gallery.ts
  var SELECTOR_SECTION = "[data-flip-gallery]";
  var FlipGallery = class extends Section {
    constructor() {
      super(...arguments);
      __publicField(this, "handleWheelBound");
      // Drag state
      __publicField(this, "isDragging", false);
      __publicField(this, "dragMoved", false);
      __publicField(this, "dragStartX", 0);
      __publicField(this, "scrollStartX", 0);
      // Bound handlers for add/remove
      __publicField(this, "onMouseDownBound");
      __publicField(this, "onMouseMoveBound");
      __publicField(this, "onMouseUpBound");
      __publicField(this, "onClickBound");
      __publicField(this, "scrollAnimationFrame", null);
      __publicField(this, "scrollTarget", 0);
      __publicField(this, "scrollVelocity", 0);
    }
    queryChildren(container) {
      this.container = container;
    }
    attachEvents() {
      if (!this.container) return;
      this.onMouseDownBound = this.onMouseDown.bind(this);
      this.onMouseMoveBound = this.onMouseMove.bind(this);
      this.onMouseUpBound = this.onMouseUp.bind(this);
      this.onClickBound = this.onClick.bind(this);
      this.container.addEventListener("mousedown", this.onMouseDownBound);
      document.addEventListener("mousemove", this.onMouseMoveBound);
      document.addEventListener("mouseup", this.onMouseUpBound);
      this.container.addEventListener("click", this.onClickBound, true);
      if (window.matchMedia("(pointer: fine)").matches) {
        this.handleWheelBound = this.handleWheel.bind(this);
        this.container.addEventListener("wheel", this.handleWheelBound, { passive: false });
      }
    }
    // (typo kept if something else calls it; consider renaming to detachEvents in your codebase)
    detatchEvents() {
      if (!this.container) return;
      if (this.handleWheelBound) {
        this.container.removeEventListener("wheel", this.handleWheelBound);
      }
      if (this.onMouseDownBound) this.container.removeEventListener("mousedown", this.onMouseDownBound);
      if (this.onClickBound) this.container.removeEventListener("click", this.onClickBound, true);
      if (this.onMouseMoveBound) document.removeEventListener("mousemove", this.onMouseMoveBound);
      if (this.onMouseUpBound) document.removeEventListener("mouseup", this.onMouseUpBound);
      if (this.scrollAnimationFrame !== null) {
        cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
      }
      this.isDragging = false;
      this.dragMoved = false;
      this.dragStartX = 0;
      this.scrollStartX = 0;
      this.container.classList.remove("is-dragging");
    }
    // ------------------------
    // Drag handlers (now scoped)
    // ------------------------
    onMouseDown(e) {
      if (!this.container) return;
      if (!(e.target instanceof HTMLElement) || !e.target.closest(SELECTOR_SECTION)) return;
      this.isDragging = true;
      this.dragMoved = false;
      this.dragStartX = e.clientX;
      this.scrollStartX = this.container.scrollLeft;
      this.container.classList.add("is-dragging");
    }
    onMouseMove(e) {
      if (!this.container || !this.isDragging) return;
      const dx = this.dragStartX - e.clientX;
      if (Math.abs(dx) > 2) this.dragMoved = true;
      this.container.scrollLeft = this.scrollStartX + dx;
    }
    onMouseUp() {
      if (!this.container) return;
      this.isDragging = false;
      this.container.classList.remove("is-dragging");
    }
    // Prevent link clicks if dragging occurred
    onClick(e) {
      if (!this.dragMoved) return;
      const target = e.target;
      if (target && target.closest("a")) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.dragMoved = false;
    }
    // ------------------------
    // Wheel-based smooth scroll
    // ------------------------
    getMaxScroll() {
      if (!this.container) return 0;
      return Math.max(0, this.container.scrollWidth - this.container.clientWidth);
    }
    isAtLeftEdge(epsilon = 1) {
      if (!this.container) return true;
      return this.container.scrollLeft <= 0 + epsilon;
    }
    isAtRightEdge(epsilon = 1) {
      if (!this.container) return true;
      const max = this.getMaxScroll();
      return this.container.scrollLeft >= max - epsilon;
    }
    canScrollHorizontally() {
      return this.getMaxScroll() > 0;
    }
    clampScroll(val) {
      return Math.min(Math.max(val, 0), this.getMaxScroll());
    }
    smoothScrollBy(delta) {
      if (!this.container) return;
      if (this.scrollAnimationFrame !== null) {
        cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
      }
      const current = this.container.scrollLeft;
      this.scrollTarget = this.clampScroll(current + delta);
      this.scrollVelocity += delta * 0.2;
      const animate = () => {
        if (!this.container) return;
        this.scrollVelocity *= 0.8;
        const next = this.clampScroll(this.container.scrollLeft + this.scrollVelocity);
        this.container.scrollLeft = next;
        if (this.isAtLeftEdge() || this.isAtRightEdge()) {
          this.scrollVelocity = 0;
        }
        const closeToTarget = Math.abs(this.scrollTarget - next) <= 0.5;
        const velocityLow = Math.abs(this.scrollVelocity) <= 0.5;
        if (!closeToTarget || !velocityLow) {
          this.scrollAnimationFrame = requestAnimationFrame(animate);
        } else {
          this.container.scrollLeft = this.scrollTarget;
          this.scrollVelocity = 0;
          this.scrollAnimationFrame = null;
        }
      };
      animate();
    }
    // Only hijack when there's room to scroll in the wheel direction.
    handleWheel(e) {
      if (!this.container) return;
      if (e.deltaY === 0) return;
      if (!this.canScrollHorizontally()) return;
      const scrollingRight = e.deltaY > 0;
      const atLeft = this.isAtLeftEdge();
      const atRight = this.isAtRightEdge();
      if (scrollingRight && atRight || !scrollingRight && atLeft) {
        if (this.scrollAnimationFrame !== null) {
          cancelAnimationFrame(this.scrollAnimationFrame);
          this.scrollAnimationFrame = null;
          this.scrollVelocity = 0;
        }
        return;
      }
      this.smoothScrollBy(e.deltaY);
      e.preventDefault();
    }
  };
  Section.register(SELECTOR_SECTION, FlipGallery);
  function setupMenuItemLightDarkSyncTopmost() {
    const gallery = document.querySelector("[data-flip-gallery]");
    const allSlides = Array.from(
      document.querySelectorAll(".c-flip-gallery__slide")
    );
    const menuItems = Array.from(
      document.querySelectorAll(".c-main-menu__item")
    );
    const logoItems = Array.from(
      document.querySelectorAll(".c-flip-gallery__logo")
    );
    menuItems.push(...logoItems);
    if (!gallery || !allSlides.length || !menuItems.length) return;
    const visibleSlides = /* @__PURE__ */ new Set();
    const rafThrottle = (fn) => {
      let ticking = false;
      return function(...args) {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          fn.apply(this, args);
        });
      };
    };
    const overlaps = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
    function withSlidePointerEvents(fn) {
      const prev = [];
      allSlides.forEach((s, i) => {
        prev[i] = s.style.pointerEvents;
        s.style.pointerEvents = "auto";
      });
      try {
        return fn();
      } finally {
        allSlides.forEach((s, i) => s.style.pointerEvents = prev[i] || "");
      }
    }
    function topSlideAtPoint(x, y) {
      return withSlidePointerEvents(() => {
        const stack = document.elementsFromPoint(x, y);
        for (const el of stack) {
          if (!(el instanceof HTMLElement)) continue;
          if (!el.classList.contains("c-flip-gallery__slide")) continue;
          if (!visibleSlides.has(el)) continue;
          return el;
        }
        return null;
      });
    }
    const update = () => {
      const slideRects = /* @__PURE__ */ new Map();
      for (const el of visibleSlides) slideRects.set(el, el.getBoundingClientRect());
      menuItems.forEach((item) => {
        const r = item.getBoundingClientRect();
        if (r.bottom <= 0 || r.top >= (window.innerHeight || document.documentElement.clientHeight)) {
          item.classList.remove("is-light", "is-dark");
          return;
        }
        const anyOverlap = Array.from(visibleSlides).some((s) => overlaps(slideRects.get(s), r));
        if (!anyOverlap) {
          item.classList.remove("is-light", "is-dark");
          return;
        }
        const midY = Math.min(Math.max(r.top + r.height / 2, 0), window.innerHeight - 1);
        const xs = [
          Math.min(Math.max(r.left + 4, 0), window.innerWidth - 1),
          Math.min(Math.max(r.left + r.width / 2, 0), window.innerWidth - 1),
          Math.min(Math.max(r.right - 4, 0), window.innerWidth - 1)
        ];
        let topSlide = null;
        for (const x of xs) {
          const candidate = topSlideAtPoint(x, midY);
          if (candidate && overlaps(slideRects.get(candidate), r)) {
            topSlide = candidate;
            break;
          }
        }
        if (!topSlide) {
          item.classList.remove("is-light", "is-dark");
          return;
        }
        if (topSlide.classList.contains("is-light")) {
          item.classList.add("is-light");
          item.classList.remove("is-dark");
        } else if (topSlide.classList.contains("is-dark")) {
          item.classList.add("is-dark");
          item.classList.remove("is-light");
        } else {
          item.classList.remove("is-light", "is-dark");
        }
      });
    };
    const updateThrottled = rafThrottle(update);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          if (entry.isIntersecting) visibleSlides.add(el);
          else visibleSlides.delete(el);
        });
        updateThrottled();
      },
      { root: null, threshold: 0.01 }
    );
    allSlides.forEach((s) => io.observe(s));
    gallery.addEventListener("scroll", updateThrottled, { passive: true });
    window.addEventListener("scroll", updateThrottled, { passive: true });
    window.addEventListener("resize", updateThrottled);
    update();
  }
  document.addEventListener("DOMContentLoaded", setupMenuItemLightDarkSyncTopmost);
})();
